import axios from "axios";

const BASE_URL = "https://ayushiconstruction.com/api/features"; // apna backend URL

export const getGalleryCategories = () => {
  return axios.get(`${BASE_URL}/gallery-categories`);
};

export const getGalleryImagesByCategory = (categoryId) => {
  return axios.get(`${BASE_URL}/gallery-images/category/${categoryId}`);
};
